import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import packageService from "services/package";

export const getPackagesAsync = createAsyncThunk(
  "packages/getPackagesAsync",
  async (queryParams) => {
    const res = await packageService.getAll(queryParams);
    return res.data;
  }
);

export const getPackageByIdAsync = createAsyncThunk(
  "packages/getPackagesAsync",
  async ({ packageId }) => {
    const res = await packageService.getOne(packageId);
    return res.data;
  }
);

export const addPackageAsync = createAsyncThunk(
  "packages/addPackageAsync",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await packageService.create(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editPackageAsync = createAsyncThunk(
  "packages/editPackageAsync",
  async ({ packageId, data }) => {
    const res = await packageService.update(packageId, data);
    return res.data;
  }
);

export const deletePackageAsync = createAsyncThunk(
  "packages/deletePackageAsync",
  async ({ packageId }, { rejectWithValue }) => {
    try {
      await packageService.remove(packageId);
      return { packageId };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addFeatureAsync = createAsyncThunk(
  "packages/addFeatureAsync",
  async ({ packageId, data }) => {
    const res = await packageService.addFeature(packageId, data);
    return res.data;
  }
);

export const updateFeatureAsync = createAsyncThunk(
  "packages/updateFeatureAsync",
  async ({ packageId, featureId, data }) => {
    const res = await packageService.updateFeature(packageId, featureId, data);
    return res.data;
  }
);

export const deleteFeatureAsync = createAsyncThunk(
  "packages/deleteFeatureAsync",
  async ({ packageId, featureId }) => {
    const res = await packageService.deleteFeature(packageId, featureId);
    return res.data;
  }
);

export const addCurrencyAsync = createAsyncThunk(
  "packages/addCurrencyAsync",
  async ({ packageId, data }) => {
    const res = await packageService.addCurrency(packageId, data);
    return res.data;
  }
);

export const updateCurrencyAsync = createAsyncThunk(
  "packages/updateCurrencyAsync",
  async ({ packageId, currencyId, data }) => {
    const res = await packageService.updateCurrency(
      packageId,
      currencyId,
      data
    );
    return res.data;
  }
);

export const deleteCurrencyAsync = createAsyncThunk(
  "packages/deleteCurrencyAsync",
  async ({ packageId, currencyId }) => {
    const res = await packageService.deleteCurrency(packageId, currencyId);
    return res.data;
  }
);

const initialState = {
  packages: {
    items: [],
    totalCount: 0,
  },
  selectedPackage: {},
  mode: "",
  addPackage: {
    status: "idle",
    error: false,
  },
  getPackages: {
    status: "idle",
    error: false,
  },
  updatingPackage: {
    status: "idle",
    error: false,
  },
  updatingFeatures: [],
  deletingFeatures: [],
};

const packagesSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    updatePackageState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetPackagesSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(editPackageAsync.pending, (state) => {
        state.updatingPackage.status = "loading";
        state.updatingPackage.error = false;
      })
      .addCase(editPackageAsync.fulfilled, (state, action) => {
        state.updatingPackage.status = "loading";
        state.updatingPackage.error = false;
      })
      .addCase(editPackageAsync.rejected, (state, action) => {
        state.updatingPackage.status = "failed";
        state.updatingPackage.error =
          action?.payload?.messageText ||
          action?.error?.message ||
          "Unknown error";
      })
      .addCase(getPackagesAsync.pending, (state) => {
        state.getPackages.status = "loading";
        state.getPackages.error = false;
      })
      .addCase(getPackagesAsync.fulfilled, (state, action) => {
        state.getPackages.status = "idle";
        state.packages = action.payload;
      })
      .addCase(getPackagesAsync.rejected, (state, action) => {
        state.getPackages.status = "failed";
        state.getPackages.error =
          action?.payload?.messageText ||
          action?.error?.message ||
          "Unknown error";
      });
  },
});

export const { updatePackageState, resetPackagesSlice } = packagesSlice.actions;

export default packagesSlice.reducer;
